const state = {
    subjects: []
};
const getters = {
    subjects(state) {
        return state.subjects;
    },
    subjectsSelect(state) {
        return state.subjects.map(item => {
            return {
                text: item.subject_name,
                value: item.subject_id
            };
        });
    }
};
const actions = {
    addSubject({ commit }, subject) {
        commit("addSubject", subject);
    },
    getSubjects({ commit }) {
        axios.get(apiRoutes.subject.url).then(response => {
            console.log(response.data.subjects,'subjects..');
            commit("saveSubjects", response.data.subjects);
        });
    },
};
const mutations = {
    addSubject(state, subject) {
        state.subjects.push(subject);
    },
    saveSubjects(state, subjects) {
        state.subjects = [...subjects];
    }
};
export default {
    state,
    actions,
    mutations,
    getters
};
